import React, { Component } from "react";
import "../home/home.scss";
import { BlockReserveLoading } from "react-loadingg";
import Card2 from "../home/components/card2";
import Fab from '@material-ui/core/Fab';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

class EmbedCarousel extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      loading: false,
      cards: [],
      searchErrorMsg: "",
      scroll:0
    };
  }

  componentWillMount() {
    const city = this.props.location.pathname.split("/")[3];
    const carousel = this.props.location.pathname.split("/")[4];

    let url = `https://hearrealtors.herokuapp.com/carousel?city=${city}&carousal=${carousel}`;
    if(city.toUpperCase()==="SPRINGFIELD")
    {
      url = "https://commercial.herrealtors.com/api/carousel/springfield"
    }

    this.callAPI(url);
    document.addEventListener('wheel',this.zoom)
  }

 
  callAPI = (url) => {
    if (this.state.city === "") return;
    this.setState({ loading: true });
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          loading: false,
          cards: data,
          searchErrorMsg: "",
        });
        // console.log(data);
      })
      .catch((err) => {
        this.setState({
          loading: false,
          searchErrorMsg: "No results Founds",
        });
        console.log(err);
      });
  };

  zoom = (e) =>
  {
    this.myRef.current.scrollLeft=this.myRef.current.scrollLeft+e.deltaY*6;
  }

  handleLeftScroll = () =>
  {
    // this.setState({scroll:this.state.scroll+300})
    this.myRef.current.scrollLeft=this.myRef.current.scrollLeft+357;
  }

  handleRightScroll = () =>
  {
    // this.setState({scroll:this.state.scroll+300})
    console.log(this.myRef.current.scrollRight)
    console.log(this.myRef.current.scrollLeft)
    this.myRef.current.scrollLeft=this.myRef.current.scrollLeft-357;
  }

  renderCards = () => {
    return this.state.cards.length > 0
      ? this.state.cards.map((card) => (
          <div className="Home-Card-Container">
            <Card2
              address={card.address}
              baths={card.baths}
              beds={card.beds}
              family={card.family}
              price={card.price}
              imageUrl={card.imageUrl}
              sqft={card.sqft}
              link={card.link}
              // courtesy={}
            />
          </div>
        ))
      : null;
  };
  render() {
    return (
      <div>
        <div className="Embed-Cards-Wrapper" ref={this.myRef}>

        {
          this.state.searchErrorMsg
          ? 
          null
          :this.state.cards.length>0?

          <div style={{position:'absolute',left:'10px',top:'200px',zIndex:'2'}}>
            <Fab size="small" className="Embed-Fab"  aria-label="left-scroll" onClick={this.handleRightScroll} dragStartEvent={()=>{console.log('on mouse down')}}>
              <ChevronLeftIcon />
            </Fab>
          </div>
          :null
        }
        {
          this.state.searchErrorMsg
          ? 
          null
          :this.state.cards.length>0?
          <div style={{position:'absolute',right:'10px',top:'200px',zIndex:'2'}}>
            <Fab size="small" className="Embed-Fab" aria-label="right-scroll"  onClick={this.handleLeftScroll} >
              <ChevronRightIcon/>
            </Fab>
          </div>
          :null
          
        } 

       
          {this.state.searchErrorMsg
            ? this.state.searchErrorMsg
            : this.renderCards()}
        </div>
        {this.state.loading ? (
          <BlockReserveLoading color="#123abc" size="large" />
        ) : null}
      </div>
    );
  }
}

export default React.memo(EmbedCarousel);
